import React from 'react';

import Header from './Header';
import HowSection from './HowSection';
import MediaKitSection from './MediaKitSection';
import WhoSection from './WhoSection';
import WhySection from './WhySection';

const PartnersContent = (): JSX.Element => {
  const scrollPageToTop = () => {
    if (window) {
      window.scrollBy({ left: 0, top: window.scrollY * -1, behavior: 'smooth' });
    }
  };

  return (
    <main className="mx-auto max-w-[1060px]">
      <Header />
      <WhySection />
      <WhoSection scrollPageToTop={scrollPageToTop} />
      <HowSection />
      <MediaKitSection scrollPageToTop={scrollPageToTop} />
    </main>
  );
};

export default PartnersContent;
